module.exports = __webpack_public_path__ + "static/Untitled-1-22-73f12ef1d21c91771b24726be45d6140.jpg";